<template>
  <div class="home-view">
    <div class="header-box">
      <header-df class="box_width" ref="header" :isTbVideo="isTbVideo"></header-df>
    </div>
    <offline></offline>
    <div class="content" :style="{backgroundColor: backgroundColor}">
      <router-view @set-background-color="setBackgroundColor" @set-currentTab="changeTab" :class="{'box_width' : neetFixedWidth}" @set-width="changeBoxWidth" @isTb="isTb"/>
    </div>
    <footer-bottom class="footer"></footer-bottom>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";

export default {
  name: 'AdminHome',
  data () {
    return {
      backgroundColor: '',
      neetFixedWidth: true,
			isTbVideo:false
    };
  },
  computed: {
    ...mapGetters(['currTab', 'currGrade', 'currAudio', 'userInfo']),
  },
  watch: {
    $route (route) {
      this.backgroundColor = '';
      this.changeBoxWidth(true);
      this.changeKeyWord();
    },
  },
  created () {
  },
  mounted () {
    this.changeKeyWord();
  },
  methods: {
    ...mapMutations(['setCurrTab']),
    changeKeyWord () {
      this.$nextTick(() => {
        let keyword = this.$route.query.keyword;
        let header = this.$refs.header;
        header.keyWord = keyword ? keyword : '';
      })
    },
		isTb(){
			this.isTbVideo = true;
		},
    setBackgroundColor (val) {
      this.backgroundColor = val;
    },
    changeBoxWidth (val) {
      this.neetFixedWidth = val;
    }
  }
};
</script>

<style lang="less" scoped>
@import '../../assets/less/function';

.home_icon {
  .spirit(url(../../assets/images/home_icon.png));
  &.left_arrow {
    &:after {
      width: 16px;
      height: 28px;
      background-position: -272px -49px;
    }
  }
  &.right_arrow {
    &:after {
      width: 16px;
      height: 28px;
      background-position: -299px -49px;
    }
  }
}

.header-box {
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 12;
  background-color: #fff;
  border-bottom: 1px solid #eeeeee;
}

.home-view {
  .content {
    z-index: 0;
    padding-top: 64px;
  }
  .box_width {
    width: 1196px;
    margin: 0 auto;
  }
}
</style>